/**
 * Single konsultuppdrag — switch between the roles of a multi-consultant
 * assignment. Each tab controls two panels: the details box and the
 * role description.
 */
export function initKonsultuppdragRoles() {
    document.querySelectorAll('.single-konsultuppdrag').forEach((root) => {
        const tabs = Array.from(root.querySelectorAll('[data-role-tab]'));
        const panels = Array.from(root.querySelectorAll('[data-role-panel]'));

        if (tabs.length < 2) {
            return;
        }

        const select = (index) => {
            tabs.forEach((tab) => {
                const active = tab.dataset.roleTab === index;
                tab.classList.toggle('bg-pink-dark', active);
                tab.classList.toggle('text-white', active);
                tab.classList.toggle('text-black', !active);
                tab.setAttribute('aria-selected', active ? 'true' : 'false');
                tab.tabIndex = active ? 0 : -1;
            });

            panels.forEach((panel) => {
                panel.hidden = panel.dataset.rolePanel !== index;
            });
        };

        tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => select(tab.dataset.roleTab));

            tab.addEventListener('keydown', (event) => {
                if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
                    return;
                }
                event.preventDefault();
                const step = event.key === 'ArrowRight' ? 1 : -1;
                const next = tabs[(i + step + tabs.length) % tabs.length];
                select(next.dataset.roleTab);
                next.focus();
            });
        });
    });
}
